/**
 * Coupons API
 *
 * Endpoints:
 *   POST api/v1/coupons/verify - verifyCoupon
 */
import { apiClientPostRequest } from '../lib/backendRequest';
import { parseCouponSummary } from '../lib/couponSummary';

// 400 is the backend rejecting the code, 404 a code shape the router refuses. Both are
// verdicts; anything else (offline, 5xx) is a can't-check, not an invalid coupon.
const INVALID_STATUSES = [400, 404];

const couponsApi = (accessToken) => ({
  /**
   * Advisory pre-validation of a coupon code. The order price quote stays
   * the final authority on whether the coupon applies.
   *
   * Returns { data: summary } when the backend accepts the code,
   * { invalid: message, reason } when it rejects it (expired, wrong products, wrong platform, ...),
   * { error: message } for anything else - not a verdict, the caller keeps a neutral state.
   *
   * @param {string} code
   */
  async verifyCoupon(code) {
    try {
      const response = await apiClientPostRequest(
        'api/v1/coupons/verify',
        { promo_code: code },
        // Guests must stay anonymous: a bogus token answers 401 instead of a guest verdict.
        accessToken ? { Authorization: `Token ${accessToken}` } : {},
      );

      const json = await response.json();

      return { data: parseCouponSummary(json.data) };
    } catch (error) {
      if (INVALID_STATUSES.includes(error.code)) {
        return { invalid: error.body || 'This coupon is not valid.', reason: error.reason };
      }
      return { error: error.body || error.message };
    }
  },
});

export default couponsApi;
